import * as React from 'react';
import { Formik } from 'formik';
import Modal from 'react-bootstrap4-modal';
import * as Api from 'src/api';
import { Input } from 'src/components/Shared/BsInput';
import { CONTENT_TYPES } from 'src/globals';

const RenderForm = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  handleSubmit,
  isSubmitting,
  setFieldValue,
}: any) => {
  return (
    <form 
      onSubmit={(e) => {
        e.stopPropagation(); 
        handleSubmit(e);
      }} 
      autoComplete="off"
    >
      <div className="row">
        <div className="col-md-3">
          <div className="form-group">
            <label>Idioma</label>
            <select
              className="form-control"
              name="language"
              onChange={handleChange}
              value={values.language}
            >
              <option value="">Indistinto</option>
              <option value="es">Español</option>
              <option value="en">Ingles</option>
              <option value="pt">Portugues</option>
              <option value="fr">Frances</option>
              <option value="cn">Chino</option>
              <option value="it">Italiano</option>
            </select>
          </div>
        </div>
        <div className="col-md-3">
          <Input
            label="Titulo"
            type="text"
            name="title"
            onChange={handleChange}
            value={values.title}
            errors={errors}
          />
        </div>
        <div className="col-md-3">
          <Input
            label="Slug"
            type="text"
            name="slug"
            onChange={handleChange}
            value={values.slug}
            errors={errors}
          />
        </div>
        <div className="col-md-3">
          <Input
            label="Slug Padre"
            type="text"
            name="parent_slug"
            onChange={handleChange}
            value={values.parent_slug}
            errors={errors}
          />
        </div>
        <div className="col-md-3">
          <div className="form-group">
            <label>Tipo</label>
            <select
              className="form-control"
              name="type"
              onChange={handleChange}
              value={values.type}
            >
              <option value="">Indistinto</option>
              {
                Object.keys(CONTENT_TYPES).map((key: string, i: number) => {
                  return (
                    <option key={i} value={key}>{CONTENT_TYPES[key]}</option>
                  );
                })
              }
            </select>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <div className="form-group pt-3">
            <button type="submit" className="btn btn-block btn-dark">
              Buscar
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default class ContentsSearchModal extends React.Component<any, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      opened: this.props.opened,
      filters: {
        title: '',
        slug: '',
        language: 'es',
        parent_slug: '',
        type: '',
      },
      contents: [],
    };

    this.toggleModal = this.toggleModal.bind(this);
    this.search = this.search.bind(this);
  }

  public render() {
    return (
      <div>
        <Modal visible={this.props.opened} onClickBackdrop={this.props.toggleModal} dialogClassName="modal-lg">
          <div className="modal-header">
            <h5 className="modal-title">Buscar contenido</h5>
          </div>
          <div className="modal-body">
            <div className="row mb-3">
              <div className="col">
                <Formik
                  initialValues={this.state.filters}
                  enableReinitialize={true}
                  onSubmit={
                    async (values: any, { setSubmitting, setErrors, ...rest }: any) => {
                      console.log(rest);
                      try {

                        const cleanValues = Object.keys(values)
                          .reduce((acc, cur) => {
                            if (values[cur]) {
                              acc[cur] = values[cur];
                            }

                            return acc;
                          }, {});

                        await this.search(cleanValues);
                      } catch (err) {
                        if (err.response.data.errors) {
                          setErrors(err.response.data.errors);
                        }

                        setSubmitting(false);
                      }
                    }
                  }
                  render={RenderForm}
                >
                </Formik>
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="col">
                {!!this.state.contents.length && <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Nombre</th>
                      <th>Slug</th>
                      <th>Slug padre</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      this.state.contents.map((content: any, i: number) => {
                        return (
                          <tr key={i}>
                            <td>{content.id}</td>
                            <td>
                              {this.getContentData(content, 'title')}
                            </td>
                            <td>
                              {this.getContentData(content, 'slug')}
                            </td>
                            <td>
                              {this.getContentData(content, 'parent_slug')}
                            </td>
                            <td>
                              <button
                                className="btn btn-primary btn-sm btn-block"
                                type="button"
                                onClick={() => this.props.onSelect(content)}
                              >
                                Seleccionar
                              </button>
                            </td>
                          </tr>
                        );
                      })
                    }
                  </tbody>
                </table>}
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-danger" onClick={this.props.toggleModal}>
              Cancelar
            </button>
          </div>
        </Modal>
      </div>
    )
  }

  private async search(params: any) {
    const { data } = await Api.searchContentsByLanguage(params);

    this.setState({ contents: data });
  }

  private toggleModal() {
    this.setState({ opened: !this.state.opened });
  }

  private getContentData(content: any, value: string) {
    return content.ContentTranslations.map((ct: any, ii: any) => {
      return (
        <div key={ii}><b>{ct.language.toUpperCase()}:</b> {ct[value] || '-'}</div>
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/containers/Shared/ContentsSearchModal.tsx